import { QueryResult, useQuery, OperationVariables, ApolloError } from '@apollo/client';
import GET_ASSESSMENTS_SUMMARY from 'graph/queries/assessments/get-assessments-summary';
import {
  Assessment,
  Maybe,
  ProductCurriculum,
  StoreTypename,
  Student,
  StudentAssessment,
} from 'types';

export type StudentAssessmentsSummaryState = {
  student?: Maybe<Student>;
  productCurriculum?: Maybe<ProductCurriculum>;
  assessments?: Assessment[];
  results?: StudentAssessment[];
  isLoading: boolean;
  error: ApolloError | undefined;
};

export type StudentAssessmentsSummaryDispatch = {
  studentAssessmentSummaryRefetch: any;
};

export type StudentAssessmentsSummaryStore = [
  StudentAssessmentsSummaryState,
  StudentAssessmentsSummaryDispatch
];

export const getDefaultStudentAssessmentsSummaryStoreState = (): any => ({
  __typename: StoreTypename.STUDENT_ASSESSMENT_SUMMARY,
});

const useStudentAssessmentsSummaryStore = (
  studentId: number,
  curriculumId
): StudentAssessmentsSummaryStore => {
  const {
    data,
    loading,
    error,
    refetch: studentAssessmentSummaryRefetch,
  }: QueryResult<{
    student?: Maybe<Student>;
    curriculum?: Maybe<ProductCurriculum>;
    assessments?: Assessment[];
    results?: StudentAssessment[];
  }> = useQuery(GET_ASSESSMENTS_SUMMARY, {
    fetchPolicy: 'no-cache',
    variables: {
      studentWhere: {
        id: studentId,
      },
      productCurriculumWhere: {
        id: curriculumId,
      },
      assessmentsWhere: {
        productCurriculumId: curriculumId,
      },
      resultsWhere: {
        studentId: studentId,
      },
    } as OperationVariables,
  });

  return [
    {
      ...(data && {
        student: data.student,
        productCurriculum: data.curriculum,
        assessments: data.assessments,
        results: data.results,
      }),
      isLoading: loading,
      error,
    },
    {
      studentAssessmentSummaryRefetch,
    },
  ];
};

export default useStudentAssessmentsSummaryStore;
